import TextTemplatePlugin from "./TextTemplatePlugin";
import TemplateTagPlugin from "./TemplateTagPlugin";
import { Editor as TinyMCEEditor } from "tinymce/tinymce";
import TextTemplateButtonPlugin from "./TextTemplateButtonPlugin";

export type PluginRegistrationProps = { editor: TinyMCEEditor; };

export default function RegisterPlugins(editor: TinyMCEEditor) {
    TextTemplatePlugin({ editor });
    TemplateTagPlugin({ editor });
    TextTemplateButtonPlugin({ editor });
};